import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { isStaticRender } from 'helpers/ContentHelper';
import { getTags } from './SchemaHelper';

const Schema = ({ schemas }) => {
  if (schemas.length <= 0 || !isStaticRender()) return null;
  const tags = getTags(schemas);
  return <Helmet className="ft-schema-tag">{tags}</Helmet>;
};

Schema.propTypes = {
  schemas: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]),
      type: PropTypes.string,
    }),
  ),
};

export default Schema;
